import {
    Component,
    Input,
    OnInit,
    ViewChild,
    Output,
    EventEmitter
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AttachmentsService } from '@app/shared';
import { Observable } from 'rxjs';
import { ReportData } from '@app/shared/models/ftp-report';

/**
 * @title Data table with sorting, pagination, and filtering.
 */

@Component({
    selector: 'app-data-table-list',
    templateUrl: './data-table-list.component.html',
    styleUrls: ['./data-table-list.component.scss']
})
export class DataTableListComponent implements OnInit {
    displayedColumns: string[] = [
        'createdAt',
        'description',
        'user_ftp',
        'nNF',
        'id'
    ];
    id: any;

    @Output() printXML = new EventEmitter();
    @Input() received: any;

    dataSource: any;

    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    constructor(private _AttachmentsService: AttachmentsService) {}

    ngOnInit() {
        this.start();
    }

    async start() {
        let handle;
        handle = setInterval(() => {
            // if (this.received[0] && this.received) {
            this.dataSource = new MatTableDataSource<ReportData>(
                this.received.data
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            clearInterval(handle);
            // }
        }, 200);
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    downloadXML(id: any) {
        this._AttachmentsService.downloadXML(id).subscribe((blob: Blob) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `invoice`;
            link.click();
            window.URL.revokeObjectURL(link.href);
        });
    }
}

/**  Copyright 2021 LMX LMTDA. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
